import { render, staticRenderFns } from "./detail-assign.vue?vue&type=template&id=28d3fb4e&scoped=true"
import script from "./detail-assign.vue?vue&type=script&lang=js"
export * from "./detail-assign.vue?vue&type=script&lang=js"
import style0 from "./detail-assign.vue?vue&type=style&index=0&id=28d3fb4e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28d3fb4e",
  null
  
)

export default component.exports